export default {"src":"/_next/static/media/crazy_black.6218a39f.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};